import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks, IDataExportsCreateParams } from '../../types/my-types';

export const useDataExportCreate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IDataExportsCreateParams) => await (await glynt).dataExports.create(data),
    ...callbacks
  });
};
